<template>
  <div class="" v-if="item">
    <router-link :to="{
      name: 'asset', 
      params: {address: item.nft_address, id: (item.nft_id)}
      }">
      <span class="c">{{item.nft_name}}</span>
    </router-link>

    <!-- <span class="t-gray ml-1">
      {{item.nft_address}} 
      ({{item.nft_id}})
    </span> -->
  </div>
</template>

<script>

export default {
  name: 'blockNftItemInfo',
  components: {},
  props: [
    'item'
  ],
  data() {
    return {
      
    }
  },
  computed: {
    calc_owner(){
      let v = this
      let i = v.item

      let mark = ''

      if(i.type === 'mint' || i.type === 'buy' || i.type === 'trans'){
        mark = i.to
      }

      else if(i.type === 'sell' || i.type === 'cancelSell'){
        mark = i.from
      }

      return mark
    },
  },
  watch: {},
  methods: {
    
  },
  created() {
    
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  
</style>